import * as Yup from 'yup';
import { emailField, nameField, phoneField } from '../../../../utils/formSchemas';

// The shared lead rules from src/utils/formSchemas.js minus location/description — the on-page
// form only collects contact info; clinic selection and questions happen inside the self-schedule
// app after handoff.
export const onPageSelfScheduleSchema = Yup.object().shape({
    first_name: nameField(),
    last_name: nameField(),
    email: emailField(),
    phone: phoneField(),
    intent: Yup.string(),
});
